import { useState } from "react";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { SendInviteEmailRequest, ShareApplicationPerson } from "@/types/ShareApplication";

export const useSendInviteEmail = () => {
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const sendInviteEmail = async (
    financialApplicationId: string,
    person: ShareApplicationPerson
  ) => {
    setIsSending(true);
    setError(null);
    setSuccess(false);

    try {
      if (!person.validInviteId) {
        throw new Error("No valid invite ID available");
      }

      const request: SendInviteEmailRequest = {
        role: person.role,
        inviteId: person.validInviteId,
      };

      await financialApplicationApiClient.sendInviteEmail(financialApplicationId, request);
      setSuccess(true);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to send invite email";
      setError(errorMessage);
      throw err;
    } finally {
      setIsSending(false);
    }
  };

  return {
    sendInviteEmail,
    isSending,
    error,
    success,
  };
};
